import { SubTabs } from "../../components/ui";

/** Visits report | Visits dashboard | Red List report: the screens of Reports,
 * each its own address. The first two read the route plans; the third is the
 * client's progress report over the Red List. */
export default function ReportsTabs() {
  return (
    <SubTabs
      label="Reports"
      tabs={[
        { to: "/reports/visits", label: "Visits report" },
        { to: "/reports/dashboard", label: "Visits dashboard" },
        { to: "/reports/redlist", label: "Red List report" },
      ]}
    />
  );
}
